"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TICKET_STATE_EVENT_TYPE_LABELS = exports.TICKET_STATE_EVENT_TYPES = exports.TICKET_TRANSITION_ERROR_CODES = exports.TICKET_STATE_TRANSITIONS = void 0;
exports.canTransition = canTransition;
/**
 * Transizioni di stato ammesse (DEC-002). `Scartato` da qualunque stato non terminale; `Chiuso` e
 * `Scartato` sono terminali; `Risolto` torna a `In lavorazione` con la riapertura (replica del
 * segnalante o «Riapri» del responsabile). Chi applica la transizione decide il quando: questa
 * tabella dice solo se è ammessa.
 */
exports.TICKET_STATE_TRANSITIONS = {
    nuovo: ['in_lavorazione', 'scartato'],
    in_lavorazione: ['in_attesa_utente', 'risolto', 'scartato'],
    in_attesa_utente: ['in_lavorazione', 'risolto', 'scartato'],
    risolto: ['in_lavorazione', 'chiuso', 'scartato'],
    chiuso: [],
    scartato: [],
};
/** Codici di errore delle transizioni di stato, nel campo `code` del corpo di errore dell'API. */
exports.TICKET_TRANSITION_ERROR_CODES = {
    /** 409: la transizione non è ammessa da DEC-002 (o da quell'azione) a partire dallo stato corrente. */
    transitionNotAllowed: 'tickets.transizione_non_ammessa',
    /** 409: lo stato è cambiato fra la lettura e la scrittura: si ricarica il ticket. */
    stateChanged: 'tickets.stato_cambiato',
};
function canTransition(from, to) {
    return exports.TICKET_STATE_TRANSITIONS[from].includes(to);
}
/** Evento del thread per ogni cambio di stato (DEC-002 regola 1): `details` = `{ da, a, ... }`. */
exports.TICKET_STATE_EVENT_TYPES = ['stato_cambiato'];
exports.TICKET_STATE_EVENT_TYPE_LABELS = {
    stato_cambiato: 'Cambio di stato',
};
//# sourceMappingURL=ticket-transitions.js.map